function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 .499c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.523 4.477-10 10-10z",
  fill: "#FF7ABC"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 10 5)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("rect", {
  width: "4.5",
  height: "2.7",
  rx: ".5"
}), /*#__PURE__*/React.createElement("rect", {
  y: "3.6",
  width: "7.2",
  height: "2.7",
  rx: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5 7.2h8a.5.5 0 01.5.5v1.7a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5V7.7a.5.5 0 01.5-.5z"
})))));